export const DATA_BOX_TYPE = {
    SERIAL: 1,
    DVR: 2,
    IPC: 3
}

export function getDataBoxTypeName(type: number) {
    if (type === DATA_BOX_TYPE.SERIAL) {
        return "串口设备"
    } else if (type === DATA_BOX_TYPE.DVR) {
        return "硬盘录像机"
    } else if(type == DATA_BOX_TYPE.IPC) {
        return "工控机"
    }
    return ''
}

export const DATA_BOX_FREQUENCY_LIST = [
    { value: 1, label: '1 秒' },
    { value: 5, label: '5 秒' },
    { value: 10, label: '10 秒' },
    { value: 30, label: '30 秒' },
    { value: 60, label: '1 分钟' },
    { value: 2 * 60, label: '2 分钟' },
    { value: 5 * 60, label: '5 分钟' },
    { value: 10 * 60, label: '10 分钟' },
    { value: 15 * 60, label: '15 分钟' },
    { value: 30 * 60, label: '30 分钟' },
    { value: 60 * 60, label: '1 小时' },
    { value: 360 * 60, label: '6 小时' },
    { value: 1440 * 60, label: '24 小时' },
]

export const DATA_BOX_TYPE_LIST = [
    { value: DATA_BOX_TYPE.SERIAL, label: '串口设备' },
    { value: DATA_BOX_TYPE.DVR, label: '硬盘录像机' },
    { value: DATA_BOX_TYPE.IPC, label: '工控机' },
]

export const DATA_BOX_MODEL_TYPE = {
    SERIAL: 1,
    DVR: 2,
    IPC: 3
}

/**
 * 采集箱数据库表名
 */
export const DATA_BOX_TABLE_NAME = 'data_box';

export const DATA_BOX_COMPONENT_TYPE = {
    1: 'serial',
    2: 'dvr',
    3: 'ipc',
}